import { Layers } from "appworks/graphics/layers/layers";
import { SpineContainer } from "appworks/graphics/pixi/spine-container";
import { UIFlagState } from "appworks/ui/flags/ui-flag-state";
import { uiFlags, UIMenuFlag } from "appworks/ui/flags/ui-flags";
import { UIHook } from "appworks/ui/flags/ui-hooks";
import { gameLayers, LayerNames } from "game-layers";

export function DMFSetupLayers() {

    const layerOrder = {
        default: [
            LayerNames.Templates,
            LayerNames.Background,
            LayerNames.MatrixBackground,
            LayerNames.MatrixContent,
            LayerNames.Anticipation,
            LayerNames.SymbolAnimations,
            LayerNames.FreespinsIntro,
            LayerNames.MatrixForeground,
            LayerNames.Paylines,
            LayerNames.PaytableButton,
            LayerNames.ReelDust,
            LayerNames.InstantWins,
            LayerNames.PaytableCommon,
            LayerNames.PaytableContent,
            LayerNames.JackpotValues,
            LayerNames.TigerHeader,
            LayerNames.CelebrationBackground,
            LayerNames.CelebrationContent,
            LayerNames.CelebrationForeground,
            LayerNames.Menus,
            LayerNames.Header,
            LayerNames.Turbo,
            LayerNames.MenuContent,
            LayerNames.BetBar,
            LayerNames.Autoplay,
            LayerNames.SmartButton,
            LayerNames.Skip,
            LayerNames.Footer,
            LayerNames.Prompts,
            LayerNames.Jurisdiction,
            LayerNames.Freegames,
            LayerNames.History
        ],
        paytable: [
            LayerNames.Templates,
            LayerNames.Background,
            LayerNames.MatrixBackground,
            LayerNames.MatrixContent,
            LayerNames.Anticipation,
            LayerNames.SymbolAnimations,
            LayerNames.FreespinsIntro,
            LayerNames.MatrixForeground,
            LayerNames.CelebrationBackground,
            LayerNames.CelebrationContent,
            LayerNames.CelebrationForeground,
            LayerNames.Paylines,
            LayerNames.PaytableButton,
            LayerNames.ReelDust,
            LayerNames.InstantWins,
            LayerNames.PaytableCommon,
            LayerNames.PaytableContent,
            LayerNames.JackpotValues,
            LayerNames.TigerHeader,
            LayerNames.Menus,
            LayerNames.Header,
            LayerNames.Turbo,
            LayerNames.MenuContent,
            LayerNames.BetBar,
            LayerNames.Autoplay,
            LayerNames.SmartButton,
            LayerNames.Skip,
            LayerNames.Footer,
            LayerNames.Prompts,
            LayerNames.Jurisdiction,
            LayerNames.Freegames,
            LayerNames.History
        ]
    };

    Layers.setLayerOrderConfig(layerOrder, LayerNames);

    gameLayers.Background.onSceneEnter.addOnce((scene: string) => {
        if (scene === "default") {
            const fsSpine: SpineContainer = gameLayers.Background.getSpine("fs_spine");
            fsSpine.visible = false;
            const bgSpine: SpineContainer = gameLayers.Background.getSpine("bg_spine");
            bgSpine.play("loop");
        }
    });

    const paytableMenuFlagHook: UIHook = uiFlags.hook(new UIFlagState(UIMenuFlag.PAYTABLE));
    paytableMenuFlagHook.on.add(() => Layers.setLayerOrder("paytable"));
    paytableMenuFlagHook.off.add(() => Layers.setLayerOrder("default"));
}
